<div class="min-h-[100vh] text-black dark:text-white">
  <div class="px-4 sm:px-8 lg:px-12 xl:px-16 py-8">
    <div
      class="p-4 mb-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 sm:p-6 dark:bg-gray-800"
    >
      <form [formGroup]="jobForm" (ngSubmit)="onFormSubmit()">
        <div class="flex flex-col md:flex-row">
          <div class="w-full mx-2" [dir]="languageDirection">
            <label
              for="job-title"
              class="block mb-1 px-2 text-sm font-medium text-gray-900 dark:text-white"
              >
              {{"JOBS.JOB-TITLE" | translate}}
            </label>
            <div class="flex mb-4">
              <label
                for="job-title"
                class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600"
              >
                <ng-icon name="bootstrapBriefcaseFill"></ng-icon>
              </label>
              <div class="relative w-full">
                <input
                  id="job-title"
                  type="text"
                  (focus)="onfieldFocused('jobTitle')"
                  (blur)="onFieldBlurd('jobTitle')"
                  placeholder="Example: Software Developer"
                  formControlName="jobTitle"
                  autocomplete="off"
                  class="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 w-full text-sm border-gray-300 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                <!-- Job title dropdown list -->
                 @if(showSelectableJobTitleOptions && (selectableJobTitles$ | async)?.length ?? 0 > 0){
                   <div class="absolute z-50 mt-1 w-full bg-white border-x border-b border-gray-200 dark:bg-gray-700 shadow-2xl rounded-b-xl">
                     <ul class="max-h-48 overflow-auto rounded-md py-1">
                       <li *ngFor="let option of (selectableJobTitles$ | async)"
                           class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/50 px-4 py-2"
                           (mousedown)="selectOption('jobTitle', option)">
                         {{ option }}
                       </li>
                     </ul>
                   </div>
                 }
              </div>
            </div>
          </div>
          <div class="flex flex-row w-full">
            <div class="w-full mx-2" [dir]="languageDirection">
              <label
                for="job-location"
                class="block mb-1 px-2 text-sm font-medium text-gray-900 dark:text-white">
                {{"JOBS.LOCATION" | translate}}
              </label>
              <div class="flex mb-4">
                <label
                  for="job-location"
                  class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600"
                >
                  <ng-icon name="bootstrapGeoAltFill"></ng-icon>
                </label>
                <div class="relative w-full">
                  <input
                    id="job-location"
                    type="text"
                    placeholder="Example: Berlin"
                    (focus)="onfieldFocused('location')"
                    (blur)="onFieldBlurd('location')"
                    formControlName="location"
                    autocomplete="off"
                    class="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 w-full text-sm border-gray-300 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                  <!-- Dropdown list -->
                  @if(showSelectableLocationOptions && (selectableLocations$ | async)?.length ?? 0 > 0){
                    <div class="absolute z-50 mt-1 w-full bg-white border-x border-b border-gray-200 dark:bg-gray-700 shadow-2xl rounded-b-xl">
                      <ul class="max-h-48 overflow-auto rounded-md py-1">
                        <li *ngFor="let option of (selectableLocations$ | async)"
                            class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/50 px-4 py-2"
                            (mousedown)="selectOption('location', option)">
                          {{ option }}
                        </li>
                      </ul>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="flex items-center mt-4">
              <button
                type="submit"
                class="flex text-white w-full bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                <div class="hidden md:block">{{"JOBS.SEARCH" | translate}}</div>
                <div class="md:hidden align-middle content-center">
                  <ng-icon name="bootstrapSearch"></ng-icon>
                </div>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div
      id="options"
      class="hidden sm:flex flex-row h-10 w-full px-8 justify-end"
    >
      <div class="flex items-center content-center px-2">
        <button (click)="showResultsInRows()">
          <div
            class="twoRows dark:bg-white"
            [ngClass]="{
              'white-svg': (colorTheme$ | async) === 'dark',
              'show-row-selected': !resultsInGrid
            }"
          ></div>
        </button>
      </div>
      <div class="flex items-center content-center">
        <button (click)="showResultsInGrid()">
          <div
            class="grid-icon dark:bg-white"
            [ngClass]="{
              'white-svg': (colorTheme$ | async) === 'dark',
              'show-row-selected': resultsInGrid
            }"
          ></div>
        </button>
      </div>
    </div>
    @if (isLoading$ | async) {
      <!-- TODO: what is going to happen to the following component -->
      <app-jobs-skeleton></app-jobs-skeleton>
    } @else if (!(isLoading$ | async)) {
      @if (((totalJobs$ | async) ?? 0) === 0) {
        <div class="col-span-full my-8">
          <div class="flex justify-center text-gray-500 dark:text-gray-400">
            <h1 [dir]="languageDirection" class="text-xl text-center">
              {{ 'HOME.JOBS.NO-JOBS-AVAILABLE' | translate }}
            </h1>
          </div>
        </div>
      } @else {
        @if (resultsInGrid) {
          <div
            class="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 mx-4 mb-4 grid-rever"
            [dir]="languageDirection"
          >
            <div
              *ngFor="let job of openJobs$ | async"
              class="bg-white border border-gray-200 rounded-xl shadow dark:bg-gray-800 dark:border-gray-700 hover:scale-[1.005]"
            >
              <a  [routerLink]="['description',job.attributes.slug]"
                  [relativeTo]="activatedRoute"
                  class="w-full cursor-pointer">
                <div class="w-full h-28">
                  <img
                    class="p-4 rounded-t-lg w-full h-28 bg-contain"
                    [src]="job.attributes.company_logo?.data?.attributes?.url"
                    [alt]="job.attributes.company_name"
                  />
                </div>
                <div class="p-5">
                  <div class="flex flex-row">
                    <h5
                      class="w-full flex justify-start text-sm xxl:text-lg font-bold tracking-tight text-gray-900 dark:text-white"
                    >
                      {{ job.attributes.title }}
                    </h5>
                  </div>
                  <div class="flex flex-col pt-2 pb-4">
                    <div
                      id="location"
                      class="flex text-sm text-gray-700 dark:text-gray-400 items-center mb-2"
                    >
                      <ng-icon
                        name="bootstrapGeoAltFill"
                        class="mx-2"
                      ></ng-icon>
                      {{ job.attributes.location }}
                    </div>
                    <div
                      id="startDate"
                      class="flex text-sm text-gray-700 dark:text-gray-400 items-center mb-2"
                    >
                      <ng-icon name="bootstrapBriefcase" class="mx-2"></ng-icon>
                      {{ job.attributes.hiring_date }}
                    </div>
                    <div
                      id="requiredLanguages"
                      class="flex text-sm text-gray-700 dark:text-gray-400 items-center"
                    >
                      <ng-icon name="bootstrapGlobe2" class="mx-2"></ng-icon>
                      {{ job.attributes.required_languages }}
                    </div>
                  </div>
                  <div
                    class="text-left rtl:text-right line-clamp-2 dark:text-white"
                    [ngClass]="{
                      'blur-text': (colorTheme$ | async) == 'light',
                      'blur-text-dark': (colorTheme$ | async) == 'dark'
                    }"
                  >
                    <div
                      [innerHTML]="job.attributes.your_tasks | safeHtml"
                    ></div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        } @else if (!resultsInGrid) {
          <div class="grid col-span-full mx-4 mb-4">
            <div
              *ngFor="let job of openJobs$ | async"
              class="relative flex flex-row w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 my-2 hover:scale-[1.005]"
              dir="ltr"
            >
              <img
                [routerLink]="['description', job.attributes.slug]"
                [relativeTo]="activatedRoute"
                aria-label="View job description and apply"
                class="p-4 hidden sm:flex bg-contain rounded-l-lg w-1/3 cursor-pointer"
                [src]="job.attributes.company_logo?.data?.attributes?.url"
                [alt]="job.attributes.company_name"
              />
              <a  [routerLink]="['description', job.attributes.slug]"
                  [relativeTo]="activatedRoute"
                  class="w-full cursor-pointer">
                <div class="p-4">
                  <div class="flex flex-col w-full">
                    <div class="flex flex-row">
                      <h5
                        class="w-full flex justify-start text-sm lg:text-lg font-bold tracking-tight text-gray-900 dark:text-white"
                      >
                        {{ job.attributes.title }}
                      </h5>
                    </div>
                    <div>
                      <div class="flex flex-grow flex-col xs:flex-row py-2">
                        <div
                          id="location"
                          class="flex text-sm text-gray-700 dark:text-gray-400 ltr:pr-4 rtl:pl-4 items-center"
                        >
                          <ng-icon
                            name="bootstrapGeoAltFill"
                            class="ltr:mr-2 rtl:ml-2"
                          ></ng-icon>
                          {{ job.attributes.location }}
                        </div>
                        <div
                          id="startDate"
                          class="flex text-sm text-gray-700 dark:text-gray-400 ltr:pr-4 rtl:pl-4 items-center"
                        >
                          <ng-icon
                            name="bootstrapBriefcase"
                            class="ltr:mr-2 rtl:ml-2"
                          ></ng-icon>
                          {{ job.attributes.hiring_date }}
                        </div>
                        <div
                          id="startDate"
                          class="flex text-sm text-gray-700 dark:text-gray-400 items-center"
                        >
                          <ng-icon
                            name="bootstrapGlobe2"
                            class="ltr:mr-2 rtl:ml-2"
                          ></ng-icon>
                          {{ job.attributes.required_languages }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-left rtl:text-right line-clamp-2 dark:text-white"
                      [ngClass]="{
                        'blur-text': (colorTheme$ | async) == 'light',
                        'blur-text-dark': (colorTheme$ | async) == 'dark'
                      }"
                    >
                      <div
                        [innerHTML]="job.attributes.your_tasks | safeHtml"
                      ></div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        }
      }
    }

    <div class="grid grid-cols-3 gap-3 mx-4" [dir]="languageDirection">
      @if (((totalJobs$ | async) ?? 0) > pageSize) {
        <div
          class="col-span-full sticky bottom-0 content-center right-0 items-center w-full p-4 bg-white dark:bg-gray-800 dark:border-gray-700 rounded-lg"
        >
          <div
            class="flex flex-col xs:flex-row items-center mb-4 sm:mb-0 justify-center"
          >
            <nav aria-label="Page navigation" class="mx-8">
              <ul class="flex items-center -space-x-px h-8 text-sm">
                <li *ngFor="let pagenumber of paginationList$ | async">
                  @if (pagenumber === 0) {
                    <button
                      (click)="getPage(pagenumber)"
                      class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <span class="sr-only">{{ pagenumber }}</span>
                      <svg
                        class="w-2.5 h-2.5 rtl:rotate-180"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 6 10"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 1 1 5l4 4"
                        />
                      </svg>
                    </button>
                  } @else if (pagenumber != 0 && pagenumber != -1) {
                    <button
                      (click)="getPage(pagenumber)"
                      class="px-3 h-8 border dark:border-gray-700"
                      [ngClass]="{
                        'z-10 flex items-center justify-center leading-tight text-blue-600 border-blue-300 bg-blue-50 hover:bg-blue-100 hover:text-blue-700  dark:bg-gray-700 dark:text-white cursor-not-allowed':
                          (currentSelectedPage$ | async) === pagenumber,
                        'flex items-center justify-center leading-tight text-gray-500 bg-white border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white cursor-pointer':
                          (currentSelectedPage$ | async) != pagenumber
                      }"
                    >
                      {{ pagenumber }}
                    </button>
                  } @else if (pagenumber === -1) {
                    <button
                      (click)="getPage(pagenumber)"
                      class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <span class="sr-only">Next</span>
                      <svg
                        class="w-2.5 h-2.5 rtl:rotate-180"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 6 10"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m1 9 4-4-4-4"
                        />
                      </svg>
                    </button>
                  }
                </li>
              </ul>
            </nav>
            <span
              class="text-sm font-normal text-gray-500 dark:text-gray-400 mt-2 xs:mt-0"
            >
              <span class="font-semibold text-gray-900 dark:text-white">
                {{
                  ((currentSelectedPage$ | async) ?? 0) * pageSize -
                    (pageSize - 1)
                }}
                -
                @if (
                  ((currentSelectedPage$ | async) ?? 0) * pageSize <=
                  ((totalJobs$ | async) ?? 0)
                ) {
                  {{ ((currentSelectedPage$ | async) ?? 0) * pageSize }}
                } @else {
                  {{ totalJobs$ | async }}
                }
              </span>
              {{ 'JOBS.OF' | translate }}
              <span class="font-semibold text-gray-900 dark:text-white">{{
                totalJobs$ | async
              }}</span></span
            >
          </div>
        </div>
      }
    </div>
  </div>
</div>
